const getUnilDominoData = (state) => {
  return !__IS_COMPONENTS_PORTAL__
    ? state?.variantResult?.unil_domino
    : state?.variantResult?.genes?.[state.selectedGeneIndexClinical]
        ?.unil_domino;
};

export { getUnilDominoData };
